import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_TEXT_TEMPLATES } from 'src/graphql/textTemplates.graphql'

import { inlineSelectProps } from './inlineSelectStyles'

const SMSTemplateOptions = ({
  selectedSmsTemplate,
  setSelectedSmsTemplate,
}) => {
  const { data: textTemplatesList } = useQuery(GET_TEXT_TEMPLATES, {
    variables: {
      pageInfo: {
        limit: 100,
        offset: 0,
      },
      orderBy: {
        field: 'title',
        direction: 'asc',
      },
    },
  })

  const templatesList = textTemplatesList?.textTemplates?.items ?? []
  return (
    <div className="flex flex-col gap-3 text-xs">      {templatesList.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No SMS templates found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedSmsTemplate?.textTemplateId}
          onChange={(value) =>
            setSelectedSmsTemplate({ textTemplateId: value })
          }
          data={templatesList.map((t) => ({
            value: t.textTemplateId,
            label: t.title,
          }))}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default SMSTemplateOptions
